import { Card, Col, Input, Row } from "antd";

function Education({ education }) {
  return (
    <Card bordered>
      <Row>
        <Col span={12} style={{ padding: 3 }}>
          <Input
            addonBefore="Institute Name"
            value={education.institute_name}
          />
        </Col>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Degree" value={education.degree_type} />
        </Col>
      </Row>
      <Row style={{ marginTop: 6 }}>
        <Col span={8} style={{ padding: 3 }}>
          <Input addonBefore="Location" value={education.location} />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <Input addonBefore="Range" value={education.date_range} />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <Input addonBefore="Score" value={education.score} />
        </Col>
      </Row>
    </Card>
  );
}

export default Education;
